export default "__VITE_ASSET__mbPymU7s__"